import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  box: {
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    boxSizing: "border-box",
  },
});
